// extracted by mini-css-extract-plugin
module.exports = {"action":"SimpleTableAction_action_39CAa","disabled":"SimpleTableAction_disabled_2yChg","blocked":"SimpleTableAction_blocked_iWv6a"};